// The only place that reads or writes the signed-in user in localStorage.
// `userDetails` is the profile the API returned; `sessiontoken` is what fetchData sends on every request.
const USER_KEY = 'userDetails';
const TOKEN_KEY = 'sessiontoken';
// older builds stored the (never-sent) token under this key
const LEGACY_TOKEN_KEY = 'token';

export const SESSION_EXPIRED_EVENT = 'ib:session-expired';

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    const user = raw ? JSON.parse(raw) : null;
    return user && typeof user === 'object' ? user : null;
  } catch (e) {
    return null;
  }
};

export const getSessionToken = () => localStorage.getItem(TOKEN_KEY) || null;

export const isAuthenticated = () => !!getSessionToken() && !!getStoredUser();

// `token` defaults to the one inside the profile; pass it when the API sends it separately.
export const saveSession = (user, token = user?.sessionToken) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  if (token) localStorage.setItem(TOKEN_KEY, token);
  return user;
};

// Merge a change into the stored profile (keeps the session token the API did not repeat).
export const updateStoredUser = (patch) => saveSession({ ...getStoredUser(), ...patch });

export const clearSession = () => {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LEGACY_TOKEN_KEY);
};
